import { WithdrawalCapacity } from "../../../../../core";

export const withdrawalCapacityReport = {
  searchText: "",
  dialogHability: true,
  filter: false,
  checkbox: false,
  sort: false,
  paginator: true,
  partialField: "",
  columns: [
    {
      title: "Entidades",
      name: "entityCodes",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: WithdrawalCapacity) => element.entityCodes,
    },
    {
      title: "Retiros pendientes",
      name: "pendingWithdrawalOrders",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: WithdrawalCapacity) => element.pendingWithdrawalOrders,
    },
    {
      title: "Capacidad máxima",
      name: "maximumWithdrawalCapacity",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: WithdrawalCapacity) =>
        element.maximumWithdrawalCapacity,
    },
    {
      title: "Capacidad incremental",
      name: "incrementalWithdrawalCapacity",
      type: "string",
      editable: false,
      class: "center",
      checkAll: false,
      value: (element: WithdrawalCapacity) =>
        element.incrementalWithdrawalCapacity,
    },
    {
      title: "Capacidad de pedidos en camino",
      name: "transitWithdrawalCapacity",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: WithdrawalCapacity) =>
        element.transitWithdrawalCapacity,
    },

    {
      title: "Días bloqueados",
      name: "lockDays",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: WithdrawalCapacity) => element.lockDays,
    },
  ],
};
